const PayplePlugin = {
  install(Vue, options = {}) {
    // Payple 결제 객체 생성 함수
    const createPaypleOrder = paymentInfo => {
      const {
        merchant_uid,
        user_no,
        user_name,
        mobile,
        email,
        price,
        total_amount,
        tax_free_amount,
        taxable_amount,
        vat_amount,
        goods_name,
        AuthKey,
        return_url,
        card_version, // billing | appcard
      } = paymentInfo;

      // 모바일 여부 확인
      const user = navigator.userAgent;
      const is_mobile =
        user.indexOf("iPhone") > -1 ||
        user.indexOf("Android") > -1 ||
        user.indexOf("iPad") > -1 ||
        user.indexOf("iPod") > -1;

      const cardVer = (() => {
        switch (card_version) {
          case "billing": // 빌링키 결제.
            return "01";
          case "appcard": // 앱카드 결제.
            return "02";
          default:
            return null;
        }
      })();

      // Payple 결제 객체 설정
      const obj = new Object();
      obj.PCD_PAY_TYPE = "card";
      obj.PCD_PAY_WORK = price === 0 ? "AUTH" : "PAY";
      obj.PCD_CARD_VER = cardVer; // 빌링키결제 혹은 앱카드결제

      obj.PCD_PAY_OID = merchant_uid;
      obj.PCD_PAYER_NO = user_no.substring(0, 20);
      obj.PCD_PAYER_NAME = user_name;
      obj.PCD_PAYER_HP = mobile ? mobile.replace("+82 ", "0") : "";
      obj.PCD_PAYER_EMAIL = email;
      obj.PCD_PAY_GOODS = goods_name;
      obj.PCD_PAY_TOTAL = String(price);

      obj.PCD_USER_DEFINE1 = goods_name;
      obj.PCD_USER_DEFINE2 = merchant_uid;

      // 비과세 금액 있는 복합과세 케이스 (e.g. 내집스캔페이 결제금액 중 월세액).
      if (tax_free_amount > 0) {
        obj.PCD_PAY_TOTAL = String(total_amount);
        obj.PCD_PAY_ISTAX = "Y";
        obj.PCD_PAY_TAXTOTAL = String(vat_amount);
      }

      obj.PCD_AUTH_KEY = AuthKey;
      obj.PCD_PAY_URL = return_url;

      return { obj, is_mobile };
    };

    // Vue 인스턴스에 $payple 객체 추가
    Vue.prototype.$payplePayment = {
      // 일반 결제 처리
      requestPayment(paymentInfo, callbackFunction, rstUrl, successUrl) {
        // window.console.log("requestPayment paymentInfo", paymentInfo);
        const { obj, is_mobile } = createPaypleOrder(paymentInfo);
        if (!is_mobile) {
          obj.callbackFunction = callbackFunction;
          obj.PCD_RST_URL = rstUrl;
        } else {
          obj.PCD_RST_URL = successUrl;
        }
        // window.console.log("PAYPLE obj", obj);

        // Payple 결제 모듈 호출
        if (typeof PaypleCpayAuthCheck === "function") {
          // window.console.log("PaypleCpayAuthCheck", obj);
          PaypleCpayAuthCheck(obj);
        } else {
          console.error("PaypleCpayAuthCheck error");
        }
      },
    };
  },
};

export default PayplePlugin;
